import React, { useState, useEffect } from 'react'; 
import { auth, db, storage  } from '../../Components/LoginComp/firebase';  // Ensure firebase auth is imported
import { collection, getDocs, deleteDoc, doc, addDoc } from 'firebase/firestore';
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { uploadBytesResumable } from "firebase/storage";




import './adminpanel.css';


function AdminPanel() {

  const [activeTab, setActiveTab] = useState('uploadResource');
  const [users, setUsers] = useState([]);  // State to hold users data
  const [uploads, setUploads] = useState([]);

  const [uploadProgress, setUploadProgress] = useState(0);
  // const [formData, setFormData] = useState({
  //   title: '',
  //   author: '',
  //   resourceType: '',
  //   isbn: '',
  //   publicationYear: '',
  //   description: '',
  //   resourceFile: null,
  // });

  const [formData, setFormData] = useState({
  title: '',
  author: '',
  resourceType: '',
  isbn: '',
  publicationYear: '',
  description: '',
  resourceFile: null,
  coverImage: null,
});

  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };





//fetch all users
  const fetchUsers = async () => {
    try {
      // Use the modular approach to reference the 'users' collection
      const userRef = collection(db, 'users');
      const snapshot = await getDocs(userRef);
      const usersData = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
      setUsers(usersData);
    } catch (error) {
      console.error("Error fetching users: ", error);
    }
  };

  useEffect(() => {
    if (activeTab === 'viewUsers') {
      fetchUsers();  // Fetch users when 'viewUsers' tab is active
    }
  }, [activeTab]);










  // Remove user
  const handleRemoveUser = async (userId) => {
    try {
      await deleteDoc(doc(db, 'users', userId));  // Delete user from Firestore
      setUsers(users.filter(user => user.id !== userId));  // Remove user from state
    } catch (error) {
      console.error("Error removing user: ", error);
    }
  };

  useEffect(() => {
    if (activeTab === 'viewUsers' || activeTab === 'manageUsers') {
      fetchUsers();  // Fetch users when 'viewUsers' or 'manageUsers' tab is active
    }
  }, [activeTab]);





  //fetch all uploads of contributors
  const fetchUploads = async () => {
    try {
      const uploadsRef = collection(db, 'uploadresource');
      const snapshot = await getDocs(uploadsRef);
      const uploadsData = snapshot.docs.map(async (doc) => {
        const uploadDetails = doc.data();
        const fileURL = await getDownloadURL(ref(storage, uploadDetails.fileURL)); // Get file URL from Storage
        return {
          ...uploadDetails,
          fileURL,  // Adding the file URL to the upload object
          id: doc.id,
        };
      });

      const resolvedUploads = await Promise.all(uploadsData);  // Wait for all file URLs to resolve
      setUploads(resolvedUploads);  // Set the uploads state
    } catch (error) {
      console.error("Error fetching uploads: ", error);
    }
  };

  useEffect(() => {
    fetchUploads();
  }, []);






  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  const handleLogout = async () => {
    try {
      await auth.signOut();
      // Redirect to login or homepage after logout, if needed
      window.location.href = '/login';  // Adjust the redirect path as necessary
    } catch (error) {
      console.error("Error logging out: ", error);
    }
  };

  useEffect(() => {
    document.body.classList.add('admin-panel-active');
    return () => {
      document.body.classList.remove('admin-panel-active');
    };
  }, []);



  

  return (
    <div className="admin-panel">
      <div className="top-bar">
        <ul className="tabs">
          <li
            className={`tab ${activeTab === 'uploadResource' ? 'active' : ''}`}
            onClick={() => handleTabClick('uploadResource')}
          >
            Upload Resource
          </li>



          <li
            className={`tab ${activeTab === 'viewUploads' ? 'active' : ''}`}
            Click={() => handleTabClick('viewUploads')}
          >
            View Contributor's Uploads
          </li>
          <li
            className={`tab ${activeTab === 'viewUsers' ? 'active' : ''}`}
            onClick={() => handleTabClick('viewUsers')}
          >
            View All Users
          </li>
          <li
            className={`tab ${activeTab === 'manageUsers' ? 'active' : ''}`}
            onClick={() => handleTabClick('manageUsers')}
          >
            Manage All Users
          </li>
        </ul>
        {/* Logout button in the top bar */}
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>

      <div className="main-content">



      {/* {activeTab === 'uploadResource' && (
        <div className="tab-content active">
          <h3>Upload Resource Section</h3>
          <form
            className="upload-form"
            onSubmit={async (e) => {
              e.preventDefault();

              const formData = new FormData(e.target);
              const title = formData.get("title");
              const author = formData.get("author");
              const isbn = formData.get("isbn");
              const publicationYear = formData.get("publicationYear");
              const description = formData.get("description");
              const coverImage = formData.get("coverImage");
              const pdfFile = formData.get("resourceFile");

              try {
                // Validate inputs
                if (!title || !author || !isbn || !publicationYear || !description || !coverImage || !pdfFile) {
                  alert("Please fill in all the fields and upload the required files.");
                  return;
                }

                // References for storage
                const coverImageRef = ref(storage, `coverImages/${coverImage.name}`);
                const pdfFileRef = ref(storage, `resources/${pdfFile.name}`);

                // Upload cover image
                const coverSnapshot = await uploadBytes(coverImageRef, coverImage);
                const coverImageURL = await getDownloadURL(coverSnapshot.ref);

                // Upload PDF/Docx file
                const pdfSnapshot = await uploadBytes(pdfFileRef, pdfFile);
                const pdfFileURL = await getDownloadURL(pdfSnapshot.ref);

                // Add to Firestore collection
                const resourceData = {
                  title,
                  author,
                  isbn,
                  publication_year: parseInt(publicationYear),
                  description,
                  coverImageURL,
                  pdfFileURL,
                  created_at: new Date(),
                };

                await addDoc(collection(db, "mainresources"), resourceData);

                alert("Resource uploaded successfully!");
                e.target.reset(); // Reset the form after successful upload
              } catch (error) {
                console.error("Error uploading resource: ", error.message);
                alert(`Error uploading resource: ${error.message}`);
              }
            }}
          >
            <label>
              Title:
              <input type="text" name="title" required />
            </label>

            <label>
              Author:
              <input type="text" name="author" required />
            </label>

            <label>
              ISBN:
              <input type="text" name="isbn" required />
            </label>

            <label>
              Publication Year:
              <input type="number" name="publicationYear" required min="1900" max="2100" />
            </label>

            <label>
              Description:
              <textarea name="description" rows="4" required></textarea>
            </label>

            <label>
              Upload Cover Image:
              <input type="file" name="coverImage" accept="image/*" required />
            </label>

            <label>
              Upload Resource File (PDF/DOCX):
              <input type="file" name="resourceFile" accept=".pdf,.docx" required />
            </label>

            <button type="submit" className="submit-btn">
              Upload Resource
            </button>
          </form>
        </div>
      )} */}






{activeTab === "uploadResource" && (
  <div className="tab-content active">
    <h3>Upload Resource Section</h3>
    <form
      className="upload-form"
onSubmit={async (e) => {
  e.preventDefault();

  const {
    title,
    author,
    resourceType,
    isbn,
    publicationYear,
    description,
    resourceFile,
    coverImage,
  } = formData;

  try {
    if (
      !title ||
      !author ||
      !resourceType ||
      !isbn ||
      !publicationYear ||
      !description ||
      !resourceFile ||
      !coverImage
    ) {
      alert("Please fill all fields.");
      return;
    }

    // =========================
    // Upload PDF
    // =========================

    const pdfFileRef = ref(
      storage,
      `resources/${Date.now()}_${resourceFile.name}`
    );

    const pdfUploadTask = uploadBytesResumable(
      pdfFileRef,
      resourceFile
    );

    const pdfFileURL = await new Promise((resolve, reject) => {
      pdfUploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

          setUploadProgress(Math.round(progress));
        },
        (error) => {
          reject(error);
        },
        async () => {
          const downloadURL = await getDownloadURL(
            pdfUploadTask.snapshot.ref
          );

          resolve(downloadURL);
        }
      );
    });

    // =========================
    // Upload Image
    // =========================

    const imageRef = ref(
      storage,
      `resourceImages/${Date.now()}_${coverImage.name}`
    );

    const imageUploadTask = uploadBytesResumable(
      imageRef,
      coverImage
    );

    const coverImageURL = await new Promise((resolve, reject) => {
      imageUploadTask.on(
        "state_changed",
        null,
        (error) => {
          reject(error);
        },
        async () => {
          const downloadURL = await getDownloadURL(
            imageUploadTask.snapshot.ref
          );

          resolve(downloadURL);
        }
      );
    });

    // =========================
    // Save to Firestore
    // =========================

    await addDoc(collection(db, "mainresources"), {
      title,
      author,
      resourceType,
      isbn,
      publication_year: parseInt(publicationYear),
      description,
      pdfFileURL,
      coverImageURL,
      created_at: new Date(),
    });

    alert("Uploaded Successfully!");

    setUploadProgress(0);

    setFormData({
      title: '',
      author: '',
      resourceType: '',
      isbn: '',
      publicationYear: '',
      description: '',
      resourceFile: null,
      coverImage: null,
    });

    e.target.reset();

  } catch (error) {
    console.error(error);
    alert(error.message);
  }
}}
    >




      <label>
        Title:
        <input
          type="text"
          name="title"
          value={formData.title}
          onChange={handleInputChange}
          required
        />
      </label>

      <label>
        Author:
        <input
          type="text"
          name="author"
          value={formData.author}
          onChange={handleInputChange}
          required
        />
      </label>
      


<label>
  Upload Cover Image:
  <input
    type="file"
    name="coverImage"
    accept="image/*"
    onChange={(e) =>
      setFormData({
        ...formData,
        coverImage: e.target.files[0],
      })
    }
    required
  />
</label>



      <div className="form-group-resource">
        <label>Resource Type : </label>
        <select
          name="resourceType"
          value={formData.resourceType}
          onChange={handleInputChange}
          required
        >
          <option value="">Select Resource Type</option>
          <option value="General Ophthalmology">General Ophthalmology</option>
          <option value="Anatomy & Physiology">Anatomy & Physiology</option>
          <option value="Cataracts & IOL">Cataracts & IOL</option>
          <option value="Cornea">Cornea</option>
          <option value="Differential Diagnosis & Systemic Disease">Differential Diagnosis & Systemic Disease</option>
          <option value="Examination & Testing">Examination & Testing</option>
          <option value="Eye Infections & Diseases">Eye Infections & Diseases</option>
          <option value="Glaucoma">Glaucoma</option>
          <option value="Historical Resources">Historical Resources</option>
          <option value="Low Vision">Low Vision</option>
          <option value="Neuro-Ophthalmology">Neuro-Ophthalmology</option>
          <option value="Nursing & Allied Health">Nursing & Allied Health</option>
          <option value="Optics & Physics">Optics & Physics</option>
          <option value="Patient Education">Patient Education</option>
          <option value="Pediatrics & Strabismus">Pediatrics & Strabismus</option>
          <option value="Perception">Perception</option>
          <option value="Refractive Errors">Refractive Errors</option>
          <option value="Retina">Retina</option>
          <option value="Surgery">Surgery</option>
          <option value="Trauma">Trauma</option>
          <option value="Journal Article">Article</option>
          <option value="Clinical Resource">Clinical Resource</option>
          <option value="E-book">E-book</option>
          <option value="Conference Paper">Conference Paper</option>
          <option value="Research">Research</option>

          <option value="General Ophthalmology">General Ophthalmology</option>
          <option value="Anatomy & Physiology">Anatomy & Physiology</option>
          <option value="Cataracts & IOL">Cataracts & IOL</option>
          <option value="Cornea">Cornea</option>
          <option value="Differential Diagnosis & Systemic Disease">Differential Diagnosis & Systemic Disease</option>
          <option value="Examination & Testing">Examination & Testing</option>
          <option value="Eye Infections & Diseases">Eye Infections & Diseases</option>
          <option value="Glaucoma">Glaucoma</option>
          <option value="Historical Resources">Historical Resources</option>
          <option value="Low Vision">Low Vision</option>
          <option value="Neuro-Ophthalmology">Neuro-Ophthalmology</option>
          <option value="Nursing & Allied Health">Nursing & Allied Health</option>
          <option value="Optics & Physics">Optics & Physics</option>
          <option value="Patient Education">Patient Education</option>
          <option value="Pediatrics & Strabismus">Pediatrics & Strabismus</option>
          <option value="Perception">Perception</option>
          <option value="Refractive Errors">Refractive Errors</option>
          <option value="Retina">Retina</option>
          <option value="Surgery">Surgery</option>
          <option value="Trauma">Trauma</option>

        </select>
      </div>

      <label>
        ISBN:
        <input
          type="text"
          name="isbn"
          value={formData.isbn}
          onChange={handleInputChange}
          required
        />
      </label>

      <label>
        Publication Year: 
        <input
          type="number"
          name="publicationYear"
          value={formData.publicationYear}
          onChange={handleInputChange}
          required
          min="1900"
          max="2100"
        />
      </label>

      <label>
        Description:
        <textarea
          name="description"
          value={formData.description}
          onChange={handleInputChange}
          rows="4"
          required
        ></textarea>
      </label>

      <label>
        Upload Resource File (PDF/DOCX):
        <input
          type="file"
          name="resourceFile"
          accept=".pdf,.docx"
          onChange={(e) => setFormData({ ...formData, resourceFile: e.target.files[0] })}
          required
        />
      </label>

      {uploadProgress > 0 && (
        <div className="progress-bar">
          <div className="progress" style={{ width: `${uploadProgress}%` }}>
            {uploadProgress}%
          </div>
        </div>
      )}

      <button type="submit" className="submit-btn">
        Upload Resource
      </button>
    </form>
  </div>
)}








{activeTab === 'viewUploads' && (
  <div className="tab-content active">
    <h3>View Contributor's Uploads</h3>
    <table className="uploads-table">
      <thead>
        <tr>
          <th>Title</th>
          <th>Author</th>
          <th>Contributor</th>
          <th>Upload Date</th>
          <th>Resource Type</th>
          <th>Description</th>
          <th>Uploaded Resource</th>
        </tr>
      </thead>
      <tbody>
        {uploads.length > 0 ? (
          uploads.map((upload) => (
            <tr key={upload.id}>
              <td>{upload.title}</td>
              <td>{upload.author}</td>
              <td>{upload.contributorName} ({upload.contributorEmail})</td>
              <td>{new Date(upload.dateOfUpload.seconds * 1000).toLocaleDateString()}</td>
              <td>{upload.resourceType}</td>
              <td>{upload.description}</td>
              <td>
                <a href={upload.fileURL} target="_blank" rel="noopener noreferrer" className="download-btn">Download</a>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="7">No uploads found.</td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
)}





        {activeTab === 'viewUsers' && (
          <div className="tab-content active">
            <h3>View All Users Section</h3>
            <table className="users-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Role</th>
                </tr>
              </thead>
              <tbody>
                {users.map(user => (
                  <tr key={user.id}>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{user.role}</td>  {/* Assuming 'role' is a field in your users' data */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}





      {/* Manage Users Tab */}
      {activeTab === 'manageUsers' && (
        <div className="tab-content active">
          <h3>Manage All Users Section</h3>
          <table className="users-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {users.map(user => (
                <tr key={user.id}>
                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  <td>{user.role}</td>
                  <td>
                    <button
                      className="remove-btn"
                      onClick={() => handleRemoveUser(user.id)}
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      </div>
    </div>
  );
}

export default AdminPanel;
